module.exports = __webpack_public_path__ + "be9919971db8b464b1baf82a3873d1ab.svg";